<template>
  <div
    class="tab-pane fade show active"
    id="nav-Recent"
    role="tabpanel"
    aria-labelledby="nav-Recent-tab"
    tabindex="0"
  >
    <div class="table-responsive table-datatble">
      <a-table class="table datatable" :columns="columns" :data-source="data">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'CourtName'">
            <h2 class="table-avatar">
              <a href="javascript:void(0);" class="avatar avatar-sm flex-shrink-0"
                ><img
                  class="avatar-img"
                  :src="require(`@/assets/img/booking/${record.Image}`)"
                  alt="User"
              /></a>
              <span class="table-head-name flex-grow-1">
                <a href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#profile-court">{{
                  record.CourtName
                }}</a>
                <span>Court 1 </span>
              </span>
            </h2>
          </template>
          <template v-else-if="column.key === 'Date'">
            <div class="table-date-time">
              <h4>
                {{ record.Date }}<span>{{ record.Time }}</span>
              </h4>
            </div>
          </template>
          <template v-else-if="column.key === 'Payment'">
            <div>
              <span class="pay-dark fs-16">{{ record.Payment }}</span>
            </div>
          </template>
          <template v-else-if="column.key === 'Details'">
            <div class="text-pink view-detail-pink">
              <a
                href="javascript:;"
                data-bs-toggle="modal"
                data-bs-target="#complete-court"
                ><i class="feather-eye"></i>View Details</a
              >
            </div>
          </template>
          <template v-else-if="column.key === 'Review'">
            <div class="table-rating">
              <div class="rating-point">
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i class="fas fa-star filled me-1"></i>
                <i :class="record.Class"></i>
              </div>
            </div>
          </template>
          <template v-else-if="column.key === 'Status'">
            <span class="badge bg-warning"
              ><i class="feather-check-square me-1"></i>Ongoing</span
            >
          </template>
          <template v-else-if="column.key === 'action'">
            <div class="text-end">
              <div class="dropdown dropdown-action table-drop-action">
                <a
                  href="javascript:void(0);"
                  class="action-icon dropdown-toggle"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  ><i class="fas fa-ellipsis-h"></i
                ></a>
                <div class="dropdown-menu dropdown-menu-end">
                  <a class="dropdown-item" href="javascript:void(0);"
                    ><i class="feather-star"></i>Write Review</a
                  >
                  <a class="dropdown-item" href="javascript:void(0);"
                    ><i class="feather-trash"></i>Delete</a
                  >
                </div>
              </div>
            </div>
          </template>
        </template>
      </a-table>
    </div>
  </div>
  <ongoing-court-modal></ongoing-court-modal>
</template>
<script>
const columns = [
  {
    title: "Court Name",
    dataIndex: "CourtName",
    key: "CourtName",
    sorter: {
      compare: (a, b) => {
        a = a.CourtName.toLowerCase();
        b = b.CourtName.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Date & Time",
    dataIndex: "Date",
    key: "Date",
    sorter: {
      compare: (a, b) => {
        a = a.Date.toLowerCase();
        b = b.Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Payment",
    dataIndex: "Payment",
    key: "Payment",
    sorter: {
      compare: (a, b) => {
        a = a.Payment.toLowerCase();
        b = b.Payment.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Details",
    dataIndex: "Details",
    key: "Details",
    sorter: {
      compare: (a, b) => {
        a = a.Details.toLowerCase();
        b = b.Details.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Review",
    dataIndex: "Review",
    key: "Review",
    sorter: {
      compare: (a, b) => {
        a = a.Review.toLowerCase();
        b = b.Review.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Status",
    dataIndex: "Status",
    key: "Status",
    sorter: {
      compare: (a, b) => {
        a = a.Status.toLowerCase();
        b = b.Status.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: true,
  },
];
const data = [
  {
    CourtName: "Bwing Sports Academy",
    Date: "Mon, Jul 15",
    Time: "02:00 PM - 04:00 PM",
    Payment: "$130",
    Class: "fas fa-star filled",
    Image: "booking-03.jpg",
  },
  {
    CourtName: "Feather Badminton",
    Date: "Mon, Jul 12",
    Time: "01:00 PM - 04:00 PM",
    Payment: "$90",
    Class: "fas fa-star",
    Image: "booking-02.jpg",
  },
  {
    CourtName: "Leap Sports Academy",
    Date: "Mon, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Payment: "$150",
    Class: "fas fa-star filled",
    Image: "booking-01.jpg",
  },

  {
    CourtName: "Marsh Academy",
    Date: "Mon, Jul 16",
    Time: "03:00 PM - 05:00 PM",
    Payment: "$100",
    Class: "fas fa-star",
    Image: "booking-04.jpg",
  },
  {
    CourtName: "Wing Sports Academy",
    Date: "Mon, Jul 16",
    Time: "06:00 PM - 08:00 PM",
    Payment: "$140",
    Class: "fas fa-star filled",
    Image: "booking-05.jpg",
  },
];
export default {
  data() {
    return {
      data,
      columns,
    };
  },
};
</script>
